import { Tooltip, Typography } from '@mui/material';

import { deviceName, DeviceType } from '../../../types/device';

interface DeviceNameProps {
    deviceType: DeviceType;
    id: number;
}

export default function DeviceName({ deviceType, id }: DeviceNameProps) {
    const name = `${deviceName(deviceType)}-${id}`;
    return (
        <Tooltip title={name} placement="right">
            <Typography variant="body2" noWrap>
                {name}
            </Typography>
        </Tooltip>
    );
}
